<template>
    <div class="container mt-4">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="card">
                    <div class="card-header">
                        {{ $t('auth.login_header') }}
                    </div>

                    <div class="card-body">
                        <validation-errors :errors="errors" v-if="errors" />

                        <form method="POST" action="/login/admin">
                            <input type="hidden" name="_token" :value="csrf">
                            <input type="hidden" name="redirect_to" :value="redirectTo" v-if="redirectTo" />

                            <div class="form-group row">
                                <label for="email" class="col-md-4 col-form-label text-md-right">{{ $t('auth.email') }}</label>

                                <div class="col-md-6">
                                    <input id="email" type="email" class="form-control" name="email" value="" required autocomplete="email" autofocus>
                                </div>
                            </div>

                            <div class="form-group row">
                                <label for="password" class="col-md-4 col-form-label text-md-right">{{ $t('auth.password') }}</label>

                                <div class="col-md-6">
                                    <input id="password" type="password" class="form-control" name="password" required autocomplete="current-password">
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-6 offset-md-4">
                                    <div class="form-check">
                                        <input id="remember" class="form-check-input" type="checkbox" name="remember">

                                        <label class="form-check-label" for="remember">
                                            {{ $t('auth.remember_me') }}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row mb-0">
                                <div class="col-md-8 offset-md-4">
                                    <button type="submit" class="btn btn-primary">
                                        {{ $t('auth.submit') }}
                                    </button>

                                    <a href="/password/reset" class="btn btn-link">
                                        {{ $t('auth.forgot_password') }}
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ValidationErrors from '@components/ValidationErrors';
    import { mapGetters } from 'vuex';

    export default {
        components: {
            ValidationErrors,
        },

        computed: {
            ...mapGetters({
                csrf: 'csrf/csrf',
            }),
        },

        data() {
            return {
                errors: window.APP.errors,
                redirectTo: this.$route.query.redirectTo,
            };
        },
    };
</script>
